import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import Image from '../ui/Image/Image'

import styles from './MissionCard.module.scss'
import RightArrow from '../../assets/images/right-tilted-arrow.svg'
import { viewDocument } from '../../utils'

const MissionCard = ({
  imageUrl,
  title,
  alternativeText,
  description,
  linkTitle,
  linkPath,
  className,
  textContainer,
}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (linkPath.includes('.pdf')) {
      viewDocument(linkPath || '')
    } else {
      navigate(linkPath)
    }
  }

  return (
    <div
      className={classNames(
        styles['card-container'],
        'grid grid-rows-2',
        className
      )}
    >
      <Image
        src={imageUrl}
        alt={alternativeText}
        className={classNames(styles.image)}
      />
      <div className={classNames(styles['bottom-container'], textContainer)}>
        <div className={classNames(styles['text-container'])}>
          <div className={classNames(styles.title)}>{title}</div>
          <div className={classNames(styles.description)}>{description}</div>
        </div>
        {linkTitle && (
          <button
            className={classNames(styles['link-container'], 'flex')}
            onClick={handleClick}
          >
            <div className={classNames(styles['link-label'])}>{linkTitle}</div>
            <Image
              src={RightArrow}
              alt="right arrow"
              className={classNames(styles['action-icon'], 'cursor-pointer')}
            />
          </button>
        )}
      </div>
    </div>
  )
}

export default MissionCard
